// Detects whether the user's region requires explicit consent before
// analytics may initialize. Timezone-based — no network call.

const CA_TIMEZONES = new Set<string>([
  'America/Toronto',
  'America/Vancouver',
  'America/Edmonton',
  'America/Halifax',
  'America/Winnipeg',
  'America/Regina',
  'America/St_Johns',
  'America/Whitehorse',
  'America/Yellowknife',
  'America/Iqaluit',
  'America/Goose_Bay',
  'America/Glace_Bay',
  'America/Moncton',
  'America/Nipigon',
  'America/Resolute',
  'America/Rankin_Inlet',
  'America/Inuvik',
  'America/Atikokan',
  'America/Pangnirtung',
  'America/Cambridge_Bay',
  'America/Dawson',
  'America/Dawson_Creek',
  'America/Creston',
  'America/Fort_Nelson',
  'America/Blanc-Sablon',
  'America/Thunder_Bay',
]);

const EU_ATLANTIC_ZONES = new Set<string>([
  'Atlantic/Reykjavik',
  'Atlantic/Madeira',
  'Atlantic/Azores',
  'Atlantic/Canary',
  'Atlantic/Faroe',
]);

export function requiresConsent(): boolean {
  if (typeof window === 'undefined') return true;

  let tz: string | undefined;
  try {
    tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return true;
  }

  if (!tz) return true;
  if (tz.startsWith('Europe/')) return true;
  if (EU_ATLANTIC_ZONES.has(tz)) return true;
  if (CA_TIMEZONES.has(tz)) return true;

  return false;
}

export type ConsentDecision = 'granted' | 'denied';
const CONSENT_STORAGE_KEY = 'vent.analytics-consent';

export function getStoredConsent(): ConsentDecision | null {
  if (typeof window === 'undefined') return null;
  try {
    const v = window.localStorage.getItem(CONSENT_STORAGE_KEY);
    return v === 'granted' || v === 'denied' ? v : null;
  } catch {
    return null;
  }
}

export function storeConsent(decision: ConsentDecision): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(CONSENT_STORAGE_KEY, decision);
  } catch {
    /* localStorage disabled */
  }
}
